import type { T_CountryItem } from '@fe/types/modules/localization/common/client/types';
import { getDialCodeFromCountryIso } from '../_helpers/functions/phone';
import COUNTRIES from './country-names-in-all-languages';

export const FILTERED_COUNTRIES = (): T_CountryItem[] =>
  COUNTRIES.map((c) => {
    const dialCode = getDialCodeFromCountryIso(c.alpha2);
    if (!dialCode) return null;

    return {
      isoCode: c.alpha2,
      name: c.en,
      dialCode,
    };
  }).filter((c): c is T_CountryItem => !!c);
